import {
  Component,
  Input,
  OnInit,
  OnChanges,
  SimpleChanges,
  ChangeDetectionStrategy
} from "@angular/core";
import { AbstractControl, Validators } from "@angular/forms";

@Component({
    selector: "app-checkbox-group",
    templateUrl: "./checkbox-group.component.html",
    styleUrls: ["./checkbox-group.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CheckboxGroupComponent implements OnInit, OnChanges {
  @Input() label: string = "";
  @Input() options: string[] = [];
  @Input() control: AbstractControl | null = null;
  @Input() disabled: boolean = false;
  @Input() required: boolean = false;
  @Input() selectedValues: string[] = [];
  @Input() dataId: string;

  ngOnInit() {
    if (this.required && this.control) {
      this.control.setValidators(this.atLeastOneSelectedValidator());
      this.control.updateValueAndValidity();
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes["disabled"] && this.control) {
      this.disabled ? this.control.disable() : this.control.enable();
    }
  }

  toggleSelection(option: string) {
    if (this.disabled || !this.control) return;

    const value = this.control.value || [];
    const index = value.indexOf(option);

    if (index === -1) {
      this.control.setValue([...value, option]);
    } else {
      this.control.setValue(value.filter((v: string) => v !== option));
    }

    this.control.markAsTouched();
    this.control.updateValueAndValidity();
  }

  isChecked(option: string): boolean {
    if (this.disabled && this.selectedValues) {
      return this.selectedValues.includes(option);
    }
    const value = this.control && this.control.value;
    return value && Array.isArray(value) && value.includes(option);
  }

  private atLeastOneSelectedValidator() {
    return (control: AbstractControl) => {
      const value = control.value || [];
      return value.length > 0 ? null : { required: true };
    };
  }
}
